import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <span>Site by Zilvinas Kupcinskas © 2020</span>
    </div>
  );
};

export default Footer;
